import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

function Sidebar() {
  const [driverStatus, setDriverStatus] = useState('offline');

  useEffect(() => {
    const savedStatus = localStorage.getItem('driverStatus') || 'offline';
    setDriverStatus(savedStatus);
    
    // Listen for status changes
    const handleStorageChange = (e) => {
      if (e.key === 'driverStatus') {
        setDriverStatus(e.newValue || 'offline');
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const toggleOnlineStatus = () => {
    const newStatus = driverStatus === 'online' ? 'offline' : 'online';
    localStorage.setItem('driverStatus', newStatus);
    setDriverStatus(newStatus);
    // Trigger storage event manually for same-window updates
    window.dispatchEvent(new StorageEvent('storage', {
      key: 'driverStatus',
      newValue: newStatus
    }));
  };

  const handleEmergency = () => {
    alert('🚨 Notfall-Modus aktiviert!\n\nDies würde normalerweise:\n- Deinen Standort an die Zentrale senden\n- Notfall-Services kontaktieren\n- Andere Fahrer benachrichtigen');
  };
  const menuItems = [
    {
      path: '/dashboard',
      icon: '📊',
      label: 'Dashboard',
      description: 'Überblick & Statistiken'
    },
    {
      path: '/events',
      icon: '🎉',
      label: 'Events',
      description: 'Kommende Veranstaltungen'
    },
    {
      path: '/map',
      icon: '🗺️',
      label: 'Karte',
      description: 'Event-Standorte'
    },
    {
      path: '/weather',
      icon: '🌤️',
      label: 'Wetter',
      description: 'Aktuelle Bedingungen'
    },
    {
      path: '/drivers',
      icon: '🚗',
      label: 'Fahrer',
      description: 'Online Kollegen'
    },
  ];

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        <div className="sidebar-section">
          <h3 className="sidebar-title">Navigation</h3>
          
          <ul className="sidebar-menu">
            {menuItems.map((item) => (
              <li key={item.path} className="sidebar-menu-item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `sidebar-link ${isActive ? 'active' : ''}`
                  }
                  end={item.path === '/dashboard'}
                >
                  <span className="sidebar-icon">{item.icon}</span>
                  <div className="sidebar-content">
                    <span className="sidebar-label">{item.label}</span>
                    <span className="sidebar-description">{item.description}</span>
                  </div>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        <div className="sidebar-section">
          <h3 className="sidebar-title">Schnellaktionen</h3>
          
          <div className="sidebar-actions">
            <button 
              className={`action-button ${driverStatus === 'online' ? 'offline' : 'online'}`}
              onClick={toggleOnlineStatus}
            >
              {driverStatus === 'online' ? '🔴 Offline gehen' : '🟢 Online gehen'}
            </button>
            <button 
              className="action-button emergency"
              onClick={handleEmergency}
            >
              🚨 Notfall
            </button>
          </div>
        </div>

        <div className="sidebar-footer">
          <div className="sidebar-info">
            <p className="info-title">Phase 1 Status</p>
            <p className="info-text">Basic Dashboard aktiv</p>
            <div className="info-progress">
              <div className="progress-bar">
                <div className="progress-fill" style={{width: '60%'}}></div>
              </div>
              <span className="progress-text">60% Complete</span>
            </div>
          </div>
        </div>
      </nav>
    </aside>
  );
}

export default Sidebar;
